module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabCage ssTab4E"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "editArea"
  }, [_c('el-form', {
    ref: "paramCk",
    attrs: {
      "model": _vm.params,
      "rules": _vm.rules
    }
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("岗位类别：")]), _vm._v(" "), _c('td', {
    staticClass: "radioText"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "type",
      "inline-message": true
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.tabSeek
    },
    model: {
      value: (_vm.params.type),
      callback: function($$v) {
        _vm.$set(_vm.params, "type", $$v)
      },
      expression: "params.type"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("主要负责人")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("其他负责人")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 3
    }
  }, [_vm._v("编辑人员")])], 1)], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("姓名：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "fullName",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.params.fullName),
      callback: function($$v) {
        _vm.$set(_vm.params, "fullName", $$v)
      },
      expression: "params.fullName"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("性别：")]), _vm._v(" "), _c('td', {
    staticClass: "radioText"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "gender",
      "inline-message": true
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.tabSeek
    },
    model: {
      value: (_vm.params.gender),
      callback: function($$v) {
        _vm.$set(_vm.params, "gender", $$v)
      },
      expression: "params.gender"
    }
  }, _vm._l((_vm.dicDats['C017']), function(item) {
    return _c('el-radio', {
      key: item.code,
      attrs: {
        "label": item.code
      }
    }, [_vm._v(_vm._s(item.name))])
  }))], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("身份证号（军官证号）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp areaTime"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "idNumber",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.params.idNumber),
      callback: function($$v) {
        _vm.$set(_vm.params, "idNumber", $$v)
      },
      expression: "params.idNumber"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_vm._v("军官证号填写示例：军字第xxxxxxx号。编号位数据实情填写。")])], 1)]), _vm._v(" "), (_vm.params.type != 3) ? _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("职务：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp areaTime"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "job",
      "inline-message": true
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择职务"
    },
    model: {
      value: (_vm.params.job),
      callback: function($$v) {
        _vm.$set(_vm.params, "job", $$v)
      },
      expression: "params.job"
    }
  }, _vm._l((_vm.dicDats['C022']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1), _vm._v(" "), (_vm.dicMap['C022'][_vm.params.job] == '其他') ? _c('el-form-item', {
    attrs: {
      "prop": "professionalOther",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.params.professionalOther),
      callback: function($$v) {
        _vm.$set(_vm.params, "professionalOther", $$v)
      },
      expression: "params.professionalOther"
    }
  })], 1) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("政治面貌：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "politicalStatus",
      "inline-message": true
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.params.politicalStatus),
      callback: function($$v) {
        _vm.$set(_vm.params, "politicalStatus", $$v)
      },
      expression: "params.politicalStatus"
    }
  }, _vm._l((_vm.dicDats['C006']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("文化程度：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "culture",
      "inline-message": true
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.params.culture),
      callback: function($$v) {
        _vm.$set(_vm.params, "culture", $$v)
      },
      expression: "params.culture"
    }
  }, _vm._l((_vm.dicDats['C005']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("手机号：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "cellphone",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.params.cellphone),
      callback: function($$v) {
        _vm.$set(_vm.params, "cellphone", $$v)
      },
      expression: "params.cellphone"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("专业：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "major",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.params.major),
      callback: function($$v) {
        _vm.$set(_vm.params, "major", $$v)
      },
      expression: "params.major"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("职称系列：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "professionalTitleSeries",
      "inline-message": true
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.params.professionalTitleSeries),
      callback: function($$v) {
        _vm.$set(_vm.params, "professionalTitleSeries", $$v)
      },
      expression: "params.professionalTitleSeries"
    }
  }, _vm._l((_vm.dicDats['C007']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("职称级别：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "titleLevel",
      "inline-message": true
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.params.titleLevel),
      callback: function($$v) {
        _vm.$set(_vm.params, "titleLevel", $$v)
      },
      expression: "params.titleLevel"
    }
  }, _vm._l((_vm.dicDats['C008']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("持有出版专业职业资格证书情况：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "certificateSituation",
      "inline-message": true
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.btnCtrls(1)
      }
    },
    model: {
      value: (_vm.params.certificateSituation),
      callback: function($$v) {
        _vm.$set(_vm.params, "certificateSituation", $$v)
      },
      expression: "params.certificateSituation"
    }
  }, _vm._l((_vm.dicDats['C009']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)], 1)]), _vm._v(" "), (_vm.params.type != 3) ? _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("是否持有岗位培训合格证书：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "isTrainCertificate",
      "inline-message": true
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.btnCtrls(1)
      }
    },
    model: {
      value: (_vm.params.isTrainCertificate),
      callback: function($$v) {
        _vm.$set(_vm.params, "isTrainCertificate", $$v)
      },
      expression: "params.isTrainCertificate"
    }
  }, _vm._l((_vm.dicDats['C018']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)], 1)]) : _vm._e()])])], 1), _vm._v(" "), _c('div', {
    staticClass: "subArea"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")]), _vm._v(" "), (_vm.modifyFlag) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.editSave('paramCk')
      }
    }
  }, [_vm._v("保存")]) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabTtl"
  }, [_c('span', [_vm._v("人员基本信息")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c8d21a7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/pressRole/SuccessivePart/forEdit/ssTab4.vue
// module id = 1752
// module chunks = 1